const NewTradeAdsEN = {
  NewTradeAds: {
    TRADE_PARTNER: 'Select Trade Ads partner',
    TRADE_PARTNER_PLACEHOLDER: 'Select partner name',
    CAMPAIGN_NAME: 'Campaign name,',
    CAMPAIGN_NAME_PLACEHOLDER: 'Type the title',
    START_DATE: 'Start Date',
    END_DATE: 'End Date',
    CAMPAIGN_GOAL: 'Campaign Goal',
    CAMPAIGN_GOAL_PALCEHOLDER: 'Select your ad objective',
    CAMPAIGN_GOAL_FORM: 'Choose the target form',
    AWARD_CAMPAIGN: 'Is this campaign awarded?',
    CAMPAIGN_BUDGET: 'Campaign budget',
    BUDGET_LIMIT: 'Limit per unit',
    BUDGET_LIMIT_TOOLTIP:
      'The investment ceiling per store limits the maximum amount to be invested in this Incentive Campaign',
    OPCIONAL: 'Optional',
    CATEGORIES: 'Categories',
    CATEGORY: 'Category: ',
    CATEGORIES_CATEGORY: 'Insert category here - Ex: Television',
    CATEGORIES_SKU: 'Enter the SKU here - Ex: 123456',
    CATEGORIES_MODEL: 'Insert the product line here - Ex: 65”',
    CONTENT_DESCRIPTION: 'Content description',
    CONTENT_DESCRIPTION_PLACEHOLDER: 'Describe the Campaign details',
    CANCEL: 'Cancel',
    CHOOSE_GROUPS: 'Choose groups',
    LINK_CLICKS: 'Clicks on the link',
    POST_ENGAGEMENT: 'Engagement',
    CONVERSIONS: 'Conversions',
    LEAD_GENERATION: 'Lead Generation',
    YES: 'Yes',
    NO: 'No',
    PERIOD: 'Period',
    NO_BUDGET_LIMIT: 'No investment limit per store',
    NOT_INFORMED: 'Not informed',
    LINE: 'Line: ',
    SKU: 'SKU: ',
    SELECTED_GROUPS: 'Selected groups',
    SEND: 'Send Campaign',
    GO_BACK: 'Go back',
    ERROR_GREATER_THAN_BUDGET: 'The limit cannot be greater than the budget',
    ERROR_MINIMUM_LIMIT: 'The limit must be at least R$10.00',
    ERROR_NO_BUDGET: 'Enter a budget',
    ERROR_MINIMUM_BUDGET: 'The budget must be at least R$10.00',
    ERROR_NO_FORM: 'Choose a form',
    ERROR_NO_GOAL: 'Choose a goal',
    SEARCH_GROUPS: 'Search Groups',
    SELECT_ALL: 'Select All',
    SEE_SUMMARY: 'See summary',
    OPEN: 'Open',
    GROUP_UNITS: 'units in the group',
    TITLE_CAMPAIGN_ERROR: 'Campaign title is required',
    CHOOSE_PARTNER_ERROR: 'Choose at least one partner',
    CHOOSE_START_DATE_ERROR: 'Choose start date',
    ADD_IMAGE_ERROR: 'Add image',
    CHOOSE_END_DATE_ERROR: 'Choose the end date',
  },
};

const NewTradeAdsPT = {
  NewTradeAds: {
    TRADE_PARTNER: 'Selecione o parceiro Trade Ads',
    TRADE_PARTNER_PLACEHOLDER: 'Selecione o nome do parceiro',
    CAMPAIGN_NAME: 'Nome da Campanha',
    CAMPAIGN_NAME_PLACEHOLDER: 'Digite o título',
    START_DATE: 'Data de Início',
    END_DATE: 'Data do Fim',
    CAMPAIGN_GOAL: 'Objetivo da Campanha',
    CAMPAIGN_GOAL_PALCEHOLDER: 'Selecione o objetivo do seu anúncio',
    CAMPAIGN_GOAL_FORM: 'Escolha o formulário de captação',
    AWARD_CAMPAIGN: 'Essa campanha é premiada?',
    CAMPAIGN_BUDGET: 'Orçamento da Campanha',
    BUDGET_LIMIT: 'Limite por unidade',
    BUDGET_LIMIT_TOOLTIP:
      'O teto de investimento por loja limita o valor máximo a ser investido nesta Campanha de Incentivo',
    OPCIONAL: 'Opcional',
    CATEGORIES: 'Categorias',
    CATEGORY: 'Categoria: ',
    CATEGORIES_CATEGORY: 'Insira aqui a categoria - Ex: Televisor',
    CATEGORIES_SKU: 'Insira aqui o SKU - Ex: 123456',
    CATEGORIES_MODEL: 'Insira aqui a linha de produto - Ex: 65”',
    CONTENT_DESCRIPTION: 'Descrição do conteúdo',
    CONTENT_DESCRIPTION_PLACEHOLDER: 'Descreva os detalhes da Campanha',
    CANCEL: 'Cancelar',
    CHOOSE_GROUPS: 'Escolher grupos',
    LINK_CLICKS: 'Clicks no link',
    POST_ENGAGEMENT: 'Engajamento',
    CONVERSIONS: 'Conversões',
    LEAD_GENERATION: 'Geração de cadastros',
    YES: 'Sim',
    NO: 'Não',
    PERIOD: 'Período',
    NO_BUDGET_LIMIT: 'Sem limite de investimento por loja',
    NOT_INFORMED: 'Não informado',
    LINE: 'Linha: ',
    SKU: 'SKU: ',
    SELECTED_GROUPS: 'Grupos selecionados',
    SEND: 'Enviar Campanha',
    GO_BACK: 'Voltar',
    ERROR_GREATER_THAN_BUDGET: 'O limite não pode ser maior que o orçamento',
    ERROR_MINIMUM_LIMIT: 'O limite deve ser no mínimo R$10,00',
    ERROR_NO_BUDGET: 'Insira um orçamento',
    ERROR_MINIMUM_BUDGET: 'O orçamento deve ser no mínimo R$10,00',
    ERROR_NO_FORM: 'Escolha um formulário',
    ERROR_NO_GOAL: 'Escolha um objetivo',
    SEARCH_GROUPS: 'Pesquisar Grupos',
    SELECT_ALL: 'Selecionar todos',
    SEE_SUMMARY: 'Ver resumo',
    OPEN: 'Abrir',
    GROUP_UNITS: 'unidades no grupo',
    TITLE_CAMPAIGN_ERROR: 'Titulo da campanha é necessário',
    CHOOSE_PARTNER_ERROR: 'Escolha ao menos um parceiro',
    CHOOSE_START_DATE_ERROR: 'Escolha a data de inicio',
    ADD_IMAGE_ERROR: 'Adicione uma imagem',
    CHOOSE_END_DATE_ERROR: 'Escolha a data final',
  },
};

const NewTradeAdsES = {
  NewTradeAds: {
    TRADE_PARTNER: 'Seleccionar socio de anuncios comerciales',
    TRADE_PARTNER_PLACEHOLDER: 'Seleccione el nombre del socio',
    CAMPAIGN_NAME: 'Nombre de la campaña',
    CAMPAIGN_NAME_PLACEHOLDER: 'Ingrese el título',
    START_DATE: 'Fecha de inicio',
    END_DATE: 'Fecha de finalización',
    CAMPAIGN_GOAL: 'Objetivo de la campaña',
    CAMPAIGN_GOAL_PALCEHOLDER: 'Seleccione el objetivo de su anuncio',
    CAMPAIGN_GOAL_FORM: 'Elija el formulario de destino',
    AWARD_CAMPAIGN: '¿ES una campaña premiada?',
    CAMPAIGN_BUDGET: 'Presupuesto de campaña',
    BUDGET_LIMIT: 'Límite por unidad',
    BUDGET_LIMIT_TOOLTIP:
      'El techo de inversión por tienda limita la cantidad máxima a invertir en esta Campaña de Incentivo',
    OPCIONAL: 'Opcional',
    CATEGORIES: 'Categorías',
    CATEGORÍA: 'Categoría: ',
    CATEGORIES_CATEGORY: 'Insertar categoría aquí - Ej: Televisión',
    CATEGORIES_SKU: 'Ingrese el SKU aquí - Ej: 123456',
    CATEGORIES_MODEL: 'Inserte la línea de producto aquí - Ej: 65”',
    CONTENT_DESCRIPTION: 'Descripción del contenido',
    CONTENT_DESCRIPTION_PLACEHOLDER: 'Describa los detalles de la campaña',
    CANCEL: 'Cancelar',
    CHOOSE_GROUPS: 'Elegir grupos',
    LINK_CLICKS: 'Clics en el enlace',
    POST_ENGAGEMENT: 'Compromiso',
    CONVERSIONS: 'Conversiones',
    LEAD_GENERATION: 'Generación de prospectos',
    YES: 'Sí',
    NO: 'No',
    PERIOD: 'Curso del tiempo',
    NO_BUDGET_LIMIT: 'Sin límite de inversión por tienda',
    NOT_INFORMED: 'No informado',
    LINE: 'Línea: ',
    SKU: 'SKU: ',
    SELECTED_GROUPS: 'Grupos seleccionados',
    SEND: 'Enviar Campaña',
    GO_BACK: 'Regresar',
    ERROR_GREATER_THAN_BUDGET: 'El límite no puede ser mayor que el presupuesto',
    ERROR_MINIMUM_LIMIT: 'El límite debe ser de al menos R$ 10,00',
    ERROR_NO_BUDGET: 'Ingrese un presupuesto',
    ERROR_MINIMUM_BUDGET: 'El presupuesto debe ser de al menos R$ 10,00',
    ERROR_NO_FORM: 'Elija un formulario',
    ERROR_NO_GOAL: 'Elige un objetivo',
    SEARCH_GROUPS: 'Buscar grupos',
    SELECT_ALL: 'Seleccionar todo',
    SEE_SUMMARY: 'Ver resumen',
    OPEN: 'Abierto',
    GROUP_UNITS: 'unidades en el grupo',
    TITLE_CAMPAIGN_ERROR: 'El título de la campaña es obligatorio',
    CHOOSE_PARTNER_ERROR: 'Elige al menos un socio',
    CHOOSE_START_DATE_ERROR: 'Elige la fecha de inicio',
    ADD_IMAGE_ERROR: 'Añadir una imagen',
    CHOOSE_END_DATE_ERROR: 'Elige la fecha de finalización',
  },
};

export { NewTradeAdsPT, NewTradeAdsEN, NewTradeAdsES };
